import React from 'react';
import {
  shape, arrayOf, string, func
} from 'prop-types';
import { RadioGroup, Radio, SelectionControlLabel } from '@one-thd/sui-atomic-components';

export const SelectableVarientRadio = ({ selectableVarient, handleChange, value }) => {
  return (
    <div className="sui-flex sui-gap-1 sui-mt-3" data-testid="selectable-variant-radio">
      <RadioGroup
        aria-labelledby="bundle-selectable-variants"
        value={value}
        name="bundle-selectable-variants"
        onChange={(event) => handleChange(event?.target?.value)}
      >
        {selectableVarient?.map((variant) => (
          <SelectionControlLabel key={variant?.value} value={variant?.value} label={variant?.name}>
            <Radio />
          </SelectionControlLabel>
        ))}
      </RadioGroup>
    </div>
  );
};

SelectableVarientRadio.displayName = 'SelectableVarientRadio';

SelectableVarientRadio.propTypes = {
  selectableVarient: arrayOf(
    shape({
      name: string.isRequired,
      value: string.isRequired
    })
  ).isRequired,
  handleChange: func.isRequired,
  value: string.isRequired
};